import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/michaelwest/Titan/titan/titan-frontend-next/src/components/ProductSearch/ProductSearch.tsx");
